import React from "react";
import { render } from "react-dom";
import Newsletter from "../widgets/Newsletter";

const newsletterContainer = document.querySelector("#newsletter");
if (newsletterContainer) render(<Newsletter elem={newsletterContainer} />, newsletterContainer);
